import { FC } from 'react';
import { DisclosureButton } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon, PlusIcon, MinusIcon } from '@heroicons/react/24/outline';
import useClassNames from 'helpers/hooks/useClassNames';
import { AccordionProps } from '.';
import Typography from '../typography';

type AccordionButtonProps = AccordionProps & {
  open: boolean;
  buttonWrapperClassName?: string;
  buttonClassName?: string;
};

const AccordionButton: FC<AccordionButtonProps> = ({
  open,
  buttonWrapperClassName,
  buttonClassName,
  openSectionTitle,
  closedSectionTitle,
  collapsedLabel,
  complete,
  incompleteLabel,
  incompleteLabelClassName = 'text-[#5e5e5e]',
  variant,
  iconClassName,
}) => {
  const buttonClassNames = useClassNames(['w-full flex justify-between', buttonClassName]);

  return (
    <DisclosureButton className={`${buttonWrapperClassName} min-h-44 w-full`}>
      <div className={buttonClassNames}>
        <div className="flex items-baseline gap-8">
          <Typography className="text-start transition">{open ? openSectionTitle : closedSectionTitle}</Typography>
          {complete ? (
            <span className="flex items-center gap-2 text-12 font-medium text-[#499082]">
              <CheckIcon className="size-14" strokeWidth={2.5} />
              Complete
            </span>
          ) : (
            incompleteLabel && <span className={`text-12 font-medium ${incompleteLabelClassName}`}>{incompleteLabel}</span>
          )}
        </div>
        <div className="flex items-center gap-8">
          {!open && collapsedLabel && <p className="font-medium text-primary-black">{collapsedLabel}</p>}
          {variant === 'arrow' ? (
            <ChevronDownIcon width={18} strokeWidth={1.25} className={`${open ? 'rotate-180' : ''} ${iconClassName}`} />
          ) : !open ? (
            <PlusIcon width={18} strokeWidth={2} className={iconClassName} />
          ) : (
            <MinusIcon width={18} strokeWidth={2} className={iconClassName} />
          )}
        </div>
      </div>
    </DisclosureButton>
  );
};

export default AccordionButton;
